import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"
import "choices.js/public/assets/styles/choices.css";

// Connects to data-controller="select"
export default class extends Controller {
  connect() {
    new Choices(this.element, {
      itemSelectText: "",
      shouldSort: false,
    })
  }
}
